import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import Login from './Login.js';

const styles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    error: {
        backgroundColor: theme.palette.error.dark,
    },
    title: {
        color: "rgb(37,106,167)",
        textAlign: 'center',
        fontFamily: [
            'Typo Round',
            'Open Sans',
            'sans-serif'

        ].join(','),
        fontSize: '28px',
    },
    new_user_text: {
        color: "rgba(0, 0, 0, 0.54)",
        padding:'0px',
        margin:'0px',
        paddingTop:'10px',
        // textAlign:'center',
        fontFamily: [

            'Open Sans',
            'sans-serif'

        ].join(','),
        fontSize: '16px',
    },
    textFieldLabel: {
        // color: "red",
        textAlign: "center",
        fontFamily: [
            'Open Sans',
            'sans-serif'

        ].join(','),
    },
    textField: {
        // marginLeft: theme.spacing.unit,
        // marginRight: theme.spacing.unit,
        // // width: 50,

        color: "#203b60",
        textAlign: "center",

        fontFamily: [
            'Open Sans',
            'sans-serif'

        ].join(','),
    },
    MtextField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        // width: 50,

        color: "#203b60",
        fontSize: "18px",
        textAlign: "center",

        fontFamily: [
            'Open Sans',
            'sans-serif'

        ].join(','),
    },
    dense: {
        marginTop: 19,
    },
    menu: {
        width: 200,
    },
    paperRoot: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        marginBottom: '15px',
        width: '100%',

    },
    paperImp: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        // marginTop: '15px'
        // width:'100%'
    },
    group: {
        margin: `${theme.spacing.unit}px 0`,
        flexDirection: 'row'
    },
    root: {
        padding: 0,
        marginBottom: '1px'



    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    button: {
        // margin: theme.spacing.unit,
        // boxShadow: 'none',
        textTransform: 'none',

        // fontWeight:'800',
        fontSize: 16,
        fontWeight: '600',
        padding: '3px 6px',
        border: '1px solid',
        color: 'white',
        // lineHeight: 1.5,
        backgroundColor: 'rgb(37,106,167)',
        borderColor: 'rgb(37,106,167)',
        fontFamily: [
            'Open Sans',
            'sans-serif'

        ].join(','),
        '&:hover': {
            backgroundColor: '#203b60',
            borderColor: '#203b60',
        },
        '&:active': {
            boxShadow: 'none',
            backgroundColor: '#0062cc',
            borderColor: '#005cbf',
        },
    },
    buttonBack: {
        // margin: theme.spacing.unit,
        // boxShadow: 'none',
        textTransform: 'none',
        fontSize: 16,
        // fontWeight:'800',
        padding: '3px 6px',
        // border: '1px solid',
        color: '#203b60',
        // lineHeight: 1.5,
        backgroundColor: '#f2f2f2',
        // borderColor: 'rgb(114, 165,199)',
        fontFamily: [
            'Open Sans',
            'sans-serif'

        ].join(','),
        // '&:hover': {
        //   backgroundColor: '#203b60',
        //   borderColor: '#203b60',
        // },
        // '&:active': {
        //   boxShadow: 'none',
        //   backgroundColor: '#0062cc',
        //   borderColor: '#005cbf',
        // },
    },

});



class SubscribeDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            new_user: false
        }
        this.confirm = this.confirm.bind(this);
        this.setNewUserForm = this.setNewUserForm.bind(this);
    }

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({
            new_user:false
        })
        this.props.close()
    };

    setNewUserForm() {
        this.setState({
            new_user: true
        })
    }

    confirm(e) {
        e.preventDefault()
        this.props.confirm()
    }

    render() {
        const { fullScreen } = this.props;
        const { classes } = this.props;

        return (
            <div>
                {/* <Button variant="outlined" color="primary" onClick={this.handleClickOpen}>
          Open responsive dialog
        </Button> */}
                <Dialog
                    fullScreen={fullScreen}
                    open={this.props.open}
                    onClose={this.handleClose}
                    aria-labelledby="responsive-dialog-title"
                >
                    {/* <DialogTitle classes={{ root: classes.title }} disableTypography id="responsive-dialog-title">{"Iniciar Sesión"}</DialogTitle> */}
                    <DialogContent>
                        {/* <Grid>
                            {this.state.new_user === true &&
                                <React.Fragment>
                                    <Grid item xs={12} >
                                        <TextField
                                            required
                                            id="company"
                                            name="company"
                                            label="Empresa"
                                            fullWidth
                                            // onChange={this.handleName}
                                            // autoComplete="fname"
                                            InputProps={{
                                                classes: {
                                                    root: classes.textField,
                                                    input: { textAlign: 'center' }
                                                },
                                            }}
                                            InputLabelProps={{
                                                classes: {
                                                    root: classes.textFieldLabel,
                                                },
                                            }}
                                        />
                                    </Grid>
                                    <Grid style={{ marginTop: "20px" }} item xs={12} >
                                        <TextField
                                            required
                                            id="name"
                                            name="name"
                                            label="Nombre"
                                            fullWidth
                                            // onChange={this.handleName}
                                            // autoComplete="fname"
                                            InputProps={{
                                                classes: {
                                                    root: classes.textField,
                                                    input: { textAlign: 'center' }
                                                },
                                            }}
                                            InputLabelProps={{
                                                classes: {
                                                    root: classes.textFieldLabel,
                                                },
                                            }}
                                        />
                                    </Grid>

                                    <Grid style={{ marginTop: "20px" }} item xs={12} >
                                        <TextField
                                            required
                                            id="email"
                                            name="email"
                                            label="E-Mail"
                                            fullWidth
                                            // onChange={this.handleName}
                                            // autoComplete="fname"
                                            InputProps={{
                                                classes: {
                                                    root: classes.textField,
                                                    input: { textAlign: 'center' }
                                                },
                                            }}
                                            InputLabelProps={{
                                                classes: {
                                                    root: classes.textFieldLabel,
                                                },
                                            }}
                                        />

                                    </Grid>
                                </React.Fragment>
                            }

                            {this.state.new_user === false &&
                                <React.Fragment>
                                    <Grid item xs={12} >
                                        <TextField
                                            required
                                            id="user_email"
                                            name="user_email"
                                            label="Correo Electrónico"
                                            fullWidth
                                            // onChange={this.handleName}
                                            // autoComplete="fname"
                                            InputProps={{
                                                classes: {
                                                    root: classes.textField,
                                                    input: { textAlign: 'center' }
                                                },
                                            }}
                                            InputLabelProps={{
                                                classes: {
                                                    root: classes.textFieldLabel,
                                                },
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} >
                                        <TextField
                                            required
                                            id="password"
                                            name="password"
                                            label="Contraseña"
                                            type="password"
                                            fullWidth
                                            // onChange={this.handleName}
                                            // autoComplete="fname"
                                            InputProps={{
                                                classes: {
                                                    root: classes.textField,
                                                    input: { textAlign: 'center' }
                                                },
                                            }}
                                            InputLabelProps={{
                                                classes: {
                                                    root: classes.textFieldLabel,
                                                },
                                            }}
                                        />
                                    </Grid>

                                </React.Fragment>
                            }


                            <Divider style={{marginTop:"20px"}} variant="middle"></Divider>
                            <DialogTitle classes={{ root: classes.new_user_text }} disableTypography id="responsive-dialog-title">¿Aún no tienes una cuenta? </DialogTitle>
                            <DialogTitle classes={{ root: classes.new_user_text }} onClick={this.setNewUserForm} disableTypography id="responsive-dialog-title"> <strong className="new_user_register">Regístrate (Gratis y en 30 segundos) </strong></DialogTitle>
                            <Divider style={{marginTop:"20px"}} variant="middle"></Divider>


                        </Grid> */}
                        <Login/>
                        {/* <DialogContentText>
                            Let Google help apps determine location. This means sending anonymous location data to
                            Google, even when no apps are running.
            </DialogContentText> */}
                    </DialogContent>
                    {/* <DialogActions>
                        <Button onClick={this.handleClose} variant="contained" className={classes.buttonBack}>
                            Cancelar
            </Button>
                        <Button onClick={this.confirm} variant="contained" className={classes.button}>
                            Confirmar
            </Button>
                    </DialogActions> */}
                </Dialog>
            </div>
        );
    }
}

SubscribeDialog.propTypes = {
    fullScreen: PropTypes.bool.isRequired,
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withMobileDialog()(SubscribeDialog));